export default __webpack_public_path__ + "static/SohneMono-Buch-6ae83e62ae95bc4fbed8bd8e7b06ccb2.woff2";